import * as React from 'react';
import { ICON_PADDING } from '../common.js';

const Sepa = ({ className ="" , color ="currentColor" , size ="24px"  })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        "data-testid": "svg-sepa",
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 1024 1024",
        fill: "none",
        style: {
            padding: ICON_PADDING
        }
    }, /*#__PURE__*/ React.createElement("path", {
        fill: color,
        d: "M500,119L833,309V458H167V309L500,119zM250,357V375H750V357L500,215L250,357zM250,708V500H333V708H250zM458,708V500H542V708H458zM667,708V500H750V708H667zM167,833V750H833V833H167z"
    }));

export { Sepa };
